import CommonTable from "@/components/commonTable";
import { calibrateAxForwardMmwRadarRequest } from "@/service/calibrate";
import { useTable } from "@/utils/useTable";
import { useMemo } from "react";
import { renderAnXingCalibrationStatus } from "./status";

interface CalibrateTableAxForwardMmwRadarProps {
    diagnosisSearchParams: any;
    carId?: number
}


const CalibrateTableAxForwardMmwRadar = (props: CalibrateTableAxForwardMmwRadarProps) => {
    const { diagnosisSearchParams = {}, carId } = props;

    const searchParams = useMemo(() => {
        const _params = {
            ...diagnosisSearchParams
        }
        if (carId) {
            _params.carId = carId;
        }
        return _params;
    }, [diagnosisSearchParams, carId]);

    const { page, limit, loading, data, totalCount, onPageChange } = useTable({
        requestFunc: calibrateAxForwardMmwRadarRequest,
        initRequest: true,
        initPageSize: 40,
        searchParams
    });

    const columns = [
        {
            title: '上报时间',
            dataIndex: 'reportTime'
        },
        {
            title: '参数版本号',
            dataIndex: 'version'
        },
        {
            title: '标定状态',
            dataIndex: 'success',
            render: renderAnXingCalibrationStatus
        },
        {
            title: '标定后位置x',
            dataIndex: 'locationX'
        },
        {
            title: '标定后位置y',
            dataIndex: 'locationY'
        },
        {
            title: '标定后位置z',
            dataIndex: 'locationZ'
        },
        {
            title: '标定后pitch',
            dataIndex: 'pitch'
        },
        {
            title: '标定后yaw',
            dataIndex: 'yaw'
        },
        {
            title: '标定后roll',
            dataIndex: 'roll'
        },
    ];

    return (
        <CommonTable
            rowKey="id"
            columns={columns}
            dataSource={data}
            pagination={{
                total: totalCount,
                current: page,
                pageSize: limit,
                onChange: onPageChange
            }}
            bordered
            loading={loading}
            scroll={{ x: '100%', y: 400 }}
        />
    );
};

export default CalibrateTableAxForwardMmwRadar;
